// Диапазоны из calculator.html пользователя. Это ориентиры, не фиксированная смета.
export const services = [
  ['site', 'Разработка сайтов', 'Новый сайт или развитие существующего'],
  ['app', 'Разработка приложений', 'iOS, Android и кроссплатформа'],
  ['mini', 'Mini Apps и боты', 'Telegram, VK и MAX'],
  ['seo', 'SEO и продвижение', 'Аудит или работа с поисковым трафиком'],
  ['maps', 'Яндекс.Карты', 'Карточка организации и филиалы'],
];
export const choices = {
  siteExists: [
    ['new', 'Нужен новый сайт'],
    ['existing', 'Сайт уже есть'],
  ],
  siteType: [
    ['landing', 'Лендинг'],
    ['corporate', 'Корпоративный сайт'],
    ['ecommerce', 'Интернет-магазин'],
    ['custom', 'Индивидуальный проект'],
  ],
  siteTasks: [
    ['redesign', 'Редизайн'],
    ['support', 'Техподдержка'],
    ['features', 'Доработки'],
    ['seo', 'SEO-оптимизация'],
  ],
  appPlatform: [
    ['ios', 'iOS'],
    ['android', 'Android'],
    ['native', 'iOS и Android: нативно', 'Отдельная разработка для каждой платформы'],
    ['cross', 'Кроссплатформа', 'Одна разработка для iOS и Android'],
  ],
  appScope: [
    ['mvp', 'MVP — первая версия'],
    ['full', 'Полноценное приложение'],
  ],
  appExtras: [
    ['publish', 'Публикация в сторах'],
    ['aso', 'ASO-продвижение'],
  ],
  miniPlatforms: [
    ['telegram', 'Telegram Mini App'],
    ['vk', 'VK Mini App'],
    ['max', 'MAX Mini App'],
    ['bot', 'Бот / чат-бот'],
  ],
  seoGoal: [
    ['turnkey', 'SEO под ключ'],
    ['audit', 'Аудит'],
    ['tech', 'Техническое SEO'],
    ['internal', 'Внутренняя оптимизация'],
    ['external', 'Внешнее продвижение'],
  ],
  mapsCount: [
    ['1', 'Один адрес'],
    ['2-5', '2–5 адресов'],
    ['6-20', '6–20 адресов'],
    ['20+', 'Более 20 адресов'],
  ],
  budget: [
    ['discuss', 'Пока не определился'],
    ['less-100', 'До 100 000 ₽'],
    ['100-300', '100 000–300 000 ₽'],
    ['300-700', '300 000–700 000 ₽'],
    ['700-1500', '700 000–1 500 000 ₽'],
    ['1500+', 'От 1 500 000 ₽'],
  ],
  deadline: [
    ['flex', 'Сроки гибкие'],
    ['asap', 'До двух недель'],
    ['month', 'В течение месяца'],
    ['quarter', '1–3 месяца'],
  ],
};
export const initialAnswers = {
  siteExists: 'new',
  siteType: '',
  siteTasks: [],
  appPlatform: '',
  appScope: 'mvp',
  appExtras: [],
  miniPlatforms: [],
  seoGoal: '',
  mapsCount: '1',
  budget: 'discuss',
  deadline: 'flex',
  siteUrl: '',
  seoUrl: '',
  mapsName: '',
  brief: '',
};
export const label = (group, value) => choices[group]?.find(([key]) => key === value)?.[1] || value;
export const money = (value) => value.toLocaleString('ru-RU') + ' ₽';
export const range = (min, max) => money(min) + ' — ' + money(max);

export function estimateProject(selected, a) {
  const lines = [];
  const add = (title, amounts, period = 'project') =>
    lines.push({ title, min: amounts[0] * 1000, max: amounts[1] * 1000, period });
  if (selected.includes('site')) {
    if (a.siteExists === 'new' && a.siteType)
      add(
        label('siteType', a.siteType),
        { landing: [80, 250], corporate: [200, 700], ecommerce: [400, 1500], custom: [300, 1200] }[
          a.siteType
        ],
      );
    if (a.siteExists === 'existing')
      a.siteTasks.forEach((task) => {
        // SEO считается один раз: отдельная SEO-ветка заменяет эту опцию.
        if (task === 'seo' && selected.includes('seo')) return;
        add(
          label('siteTasks', task),
          { redesign: [150, 600], support: [20, 80], features: [80, 400], seo: [50, 200] }[task],
          task === 'support' ? 'month' : 'project',
        );
      });
  }
  if (selected.includes('app') && a.appPlatform) {
    add(
      a.appScope === 'mvp' ? 'MVP приложения' : 'Разработка приложения',
      a.appScope === 'mvp'
        ? [300, 800]
        : { ios: [500, 1500], android: [500, 1500], native: [1000, 3000], cross: [700, 2000] }[
            a.appPlatform
          ],
    );
    if (a.appExtras.includes('aso')) add('ASO-продвижение', [50, 200], 'clarify');
    if (a.appExtras.includes('publish')) lines.push({ title: 'Публикация в сторах', quote: true });
  }
  if (selected.includes('mini'))
    a.miniPlatforms.forEach((platform) =>
      add(label('miniPlatforms', platform), platform === 'bot' ? [60, 250] : [150, 500]),
    );
  if (selected.includes('seo') && a.seoGoal)
    add(
      label('seoGoal', a.seoGoal),
      {
        turnkey: [80, 300],
        audit: [30, 100],
        tech: [40, 150],
        internal: [40, 150],
        external: [50, 200],
      }[a.seoGoal],
      ['turnkey', 'external'].includes(a.seoGoal) ? 'month' : 'project',
    );
  if (selected.includes('maps')) {
    const multiplier = { 1: 1, '2-5': 2, '6-20': 4, '20+': 8 }[a.mapsCount];
    add('Яндекс.Карты', [25 * multiplier, 80 * multiplier], 'month');
  }
  const total = (period) =>
    lines
      .filter((line) => line.period === period)
      .reduce((sum, line) => ({ min: sum.min + line.min, max: sum.max + line.max }), {
        min: 0,
        max: 0,
      });
  return { lines, project: total('project'), month: total('month') };
}

export function validateBranch(branch, a) {
  const url =
    branch === 'site' && a.siteExists === 'existing' ? a.siteUrl : branch === 'seo' ? a.seoUrl : '';
  if (url) {
    try {
      const parsed = new URL(url);
      if (!['http:', 'https:'].includes(parsed.protocol) || !parsed.hostname.includes('.'))
        return 'Укажите полный адрес сайта, например https://example.ru, или оставьте поле пустым.';
    } catch (_error) {
      return 'Укажите полный адрес сайта, например https://example.ru, или оставьте поле пустым.';
    }
  }
  if (branch === 'site' && a.siteExists === 'new' && !a.siteType) return 'Выберите тип сайта.';
  if (branch === 'site' && a.siteExists === 'existing' && !a.siteTasks.length)
    return 'Выберите хотя бы одну задачу по сайту.';
  if (branch === 'app' && !a.appPlatform) return 'Выберите платформу приложения.';
  if (branch === 'mini' && !a.miniPlatforms.length)
    return 'Выберите хотя бы одну платформу или бота.';
  if (branch === 'seo' && !a.seoGoal) return 'Выберите задачу SEO-продвижения.';
  return '';
}

export function summaryFor(selected, a) {
  return selected.map((key) => {
    let detail = '';
    if (key === 'site')
      detail =
        a.siteExists === 'new'
          ? label('siteType', a.siteType)
          : a.siteTasks
              .filter((t) => t !== 'seo' || !selected.includes('seo'))
              .map((t) => label('siteTasks', t))
              .join(', ');
    if (key === 'app')
      detail = [
        label('appPlatform', a.appPlatform),
        label('appScope', a.appScope),
        ...a.appExtras.map((t) => label('appExtras', t)),
      ]
        .filter(Boolean)
        .join(', ');
    if (key === 'mini') detail = a.miniPlatforms.map((t) => label('miniPlatforms', t)).join(', ');
    if (key === 'seo') detail = label('seoGoal', a.seoGoal);
    if (key === 'maps')
      detail = [a.mapsName, label('mapsCount', a.mapsCount)].filter(Boolean).join(', ');
    return {
      key,
      title: services.find((s) => s[0] === key)[1],
      detail: detail || 'Уточним на следующем шаге',
    };
  });
}

export function projectBrief(selected, a) {
  const estimate = estimateProject(selected, a);
  return [
    'Калькулятор Fatality — предварительная оценка',
    ...summaryFor(selected, a).map((row) => row.title + ': ' + row.detail),
    ...estimate.lines.map(
      (line) =>
        line.title +
        ': ' +
        (line.quote
          ? 'по запросу'
          : range(line.min, line.max) +
            (line.period === 'month'
              ? ' / месяц'
              : line.period === 'clarify'
                ? ' (период уточняется)'
                : ' за проект')),
    ),
    'Бюджет: ' + label('budget', a.budget),
    'Желаемые сроки: ' + label('deadline', a.deadline),
    selected.includes('site') && a.siteExists === 'existing' && a.siteUrl
      ? 'Сайт: ' + a.siteUrl
      : '',
    selected.includes('seo') && a.seoUrl ? 'Сайт для SEO: ' + a.seoUrl : '',
    a.brief,
    'Диапазоны ориентировочные. Состав, общие работы, период оплаты и сроки подтверждаются после брифинга.',
  ]
    .filter(Boolean)
    .join('\n');
}
